import { container } from 'tsyringe';
import { LandingPagesRepository } from 'packages/landing_pages/LandingPagesRepository';
import { types } from './mutations';
import { LandingPage } from 'packages/landing_pages/LandingPage';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import { SlugHelper } from 'packages/utilities/SlugHelper';
import { EntityBuilder } from '@/node_modules/@decahedron/entity';
import VueI18n from 'vue-i18n';
export var actions = {
    getLandingPagesForJob: function (_a, jobId) {
        var commit = _a.commit;
        var repository = container.resolve(LandingPagesRepository);
        commit(types.LANDING_PAGES_RETRIEVING, { jobId: jobId });
        return repository.listForJob(jobId)
            .then(function (response) { return commit(types.LANDING_PAGES_RETRIEVED, {
            jobId: jobId,
            pages: response.items,
        }); })
            .then(function () { return null; });
    },
    createDefaultLandingPage: function (_a, payload) {
        var _b;
        var commit = _a.commit, state = _a.state;
        var repository = container.resolve(LandingPagesRepository);
        var auth = container.resolve(Authenticator);
        var i18n = container.resolve(VueI18n);
        payload.delta.insert('\n').insert({
            FormLinkEmbed: {
                text: i18n.t('ats.job.landing_page_form_label'),
                color: payload.branding.color,
                onclick: null,
                formUuid: payload.form.uuid,
            },
        });
        var landingPage = EntityBuilder.buildOne(LandingPage, {
            job: payload.job,
            jobId: payload.job.id,
            slug: SlugHelper.sluggify(payload.job.name),
            name: i18n.t('ats.job.landing_page_default_name'),
            content: payload.delta,
            companyId: (_b = payload.companyId) !== null && _b !== void 0 ? _b : auth.getSelectedCompany(),
            locale: payload.form.lang,
        });
        if (payload.job.isHidden) {
            landingPage.isPublished = false;
        }
        return repository.createNewLandingPage(landingPage).then(function (landingPage) {
            commit(types.LANDING_PAGES_RETRIEVED, {
                jobId: payload.job.id,
                pages: state.pages[payload.job.id],
            });
            if (!state.pages[payload.job.id]) {
                state.pages[payload.job.id] = [landingPage];
            }
            else {
                state.pages[payload.job.id].push(landingPage);
            }
            return landingPage;
        });
    },
    createNewLandingPage: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var job = _b.job, locale = _b.locale;
        var repository = container.resolve(LandingPagesRepository);
        var auth = container.resolve(Authenticator);
        var page = new LandingPage();
        page.isPublished = false;
        page.companyId = auth.getSelectedCompany();
        page.name = 'Unlisted Page';
        page.slug = SlugHelper.sluggify(job.name);
        page.jobId = job.id;
        page.locale = locale;
        return repository.createNewLandingPage(page)
            .then(function (landingPage) {
            state.pages[job.id].push(landingPage);
            commit(types.LANDING_PAGES_RETRIEVED, {
                jobId: job.id,
                pages: state.pages[job.id],
            });
            return landingPage;
        });
    },
    updateLandingPage: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var landingPage = _b.landingPage, jobId = _b.jobId;
        var repository = container.resolve(LandingPagesRepository);
        return repository.updateLandingPage(landingPage.toSaveRequest())
            .then(function () {
            commit(types.LANDING_PAGE_UPDATED, { jobId: jobId, landingPage: landingPage });
        }).then();
    },
    showLandingPage: function (_a, stringIdentifier) {
        var commit = _a.commit, state = _a.state;
        var repository = container.resolve(LandingPagesRepository);
        commit(types.LANDING_PAGE_RETRIEVING);
        return repository.showLandingPage(stringIdentifier)
            .then(function () { return commit(types.LANDING_PAGE_RETRIEVED); })
            .then();
    },
    deleteLandingPage: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var landingPageId = _b.landingPageId, jobId = _b.jobId;
        var repository = container.resolve(LandingPagesRepository);
        return repository.delete(landingPageId).then(function () {
            commit(types.LANDING_PAGE_DELETED, { jobId: jobId, pages: state.pages[jobId], landingPageId: landingPageId });
        }).then();
    },
    publishLandingPage: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var landingPageId = _b.landingPageId, jobId = _b.jobId;
        var repository = container.resolve(LandingPagesRepository);
        return repository.publishLandingPage(landingPageId).then(function () {
            commit(types.LANDING_PAGE_PUBLISHED, { jobId: jobId, landingPageId: landingPageId });
        });
    },
    unpublishLandingPage: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var landingPageId = _b.landingPageId, jobId = _b.jobId;
        var repository = container.resolve(LandingPagesRepository);
        return repository.unpublishLandingPage(landingPageId).then(function () {
            commit(types.LANDING_PAGE_UNPUBLISHED, { jobId: jobId, landingPageId: landingPageId });
        });
    },
    linkJobLists: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var landingPageId = _b.landingPageId, jobId = _b.jobId, jobLists = _b.jobLists;
        var repository = container.resolve(LandingPagesRepository);
        var jobListIds = Array.from(jobLists, function (jobList) { return jobList.id; });
        return repository.linkJobLists(landingPageId, jobListIds).then(function () { return commit(types.JOB_LIST_LINKED, {
            landingPageId: landingPageId,
            jobId: jobId,
            jobLists: jobLists,
        }); });
    },
};
